// @flow
import districts from './districts.json'

export async function fetchDistricts(): Promise<District[]> {
  return districts
}